import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchPaymentStatus, selectView } from 'modules/giftCard';
import { userSelector } from 'modules/currentUser';
import BuyGiftCardPage from './BuyGiftCardPage.jsx';
import connectToI18n from 'modules/i18n/connectToI18n';

export class BuyGiftCardContainer extends React.Component {
    static propTypes = {
        view: PropTypes.object.isRequired,
        homeLink: PropTypes.string.isRequired,
        fetchPaymentStatus: PropTypes.func.isRequired,
        paymentUuid: PropTypes.string,
        user: PropTypes.object.isRequired,
    };

    componentDidMount() {
        if (this.props.paymentUuid) {
            this.props.fetchPaymentStatus(this.props.paymentUuid);
        }
    }

    render() {
        return (
            <BuyGiftCardPage
                view={this.props.view}
                homeLink={this.props.homeLink}
                isAnonymous={this.props.user.anonymous}
            />
        );
    }
}

export default connect(
    state => ({
        view: selectView(state),
        user: userSelector(state),
    }),
    {
        fetchPaymentStatus,
    }
)(connectToI18n(BuyGiftCardContainer));
